import type { PipeTransform } from '@angular/core';
import { Inject, Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NetworkInfoDetailsType } from '../../health/dvrs/shared/network-info';

@Pipe({
  name: 'networkInfoTypeName',
  standalone: false,
})
export class NetworkInfoTypeNamePipe implements PipeTransform {

  public constructor(
    @Inject(TranslateService) private readonly translate: TranslateService,
  ) {}

  public transform(type: NetworkInfoDetailsType): string {
    // API may return numeric (1) or string ('lan') enum values.
    const name = typeof type === 'string'? type: NetworkInfoDetailsType[type as unknown as number] ?? String(type);
    const key = `health.network-info.type.${name.toLowerCase()}`;
    const translated = this.translate.instant(key);
    return translated === key ? name : translated;
  }

}
